var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { AxiosError } from 'axios';
import { Alert, Button, DrawerBody, DrawerFooter, LoadingButton, } from '@one-thd/sui-atomic-components';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import DrawerHeader from '../drawer/drawer-header';
import { AddressFields } from '../address/address-fields';
import { validationSchema } from '../../addresses/address-form/validation';
import { mapAddAddressToRequestModel } from '../../../utils/mapping-addresses';
import { addressesApi } from '../../../api/common/addresses';
import { useAddresses } from '../../../hooks/use-addresses';
import { ERR_UNABLE_TO_SAVE } from '../../../constants/response-error-messages';
export const AddBillingAddress = ({ hideDrawer, onAdd, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { getAddresses } = useAddresses();
    const [errorMessage, setErrorMessage] = useState(null);
    const formMethods = useForm({
        defaultValues: {
            firstName: '',
            lastName: '',
            isDefault: false,
            primaryPhone: '',
            addressLine1: '',
            zipCode: '',
            cityState: '',
        },
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
    });
    const isB2B = false;
    const executeAddAddress = (requestData) => {
        return addressesApi
            .addNewAddress(isB2B, requestData)
            .then(({ data: { addresses: addr } }) => __awaiter(void 0, void 0, void 0, function* () {
            const [newAddress] = addr.address;
            if (!newAddress.addrIdentifier) {
                throw new AxiosError('Billing address is missing');
            }
            yield getAddresses({ page: 0, pageSize: 0 });
            onAdd(newAddress.addrIdentifier);
        }))
            .catch(() => {
            const { message } = ERR_UNABLE_TO_SAVE;
            setErrorMessage(message);
        })
            .finally(() => {
            setIsLoading(false);
            hideDrawer();
        });
    };
    const onSubmit = (formValues) => {
        setIsLoading(true);
        const isDefault = false;
        const requestData = mapAddAddressToRequestModel(isB2B, formValues, isDefault);
        executeAddAddress(requestData);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormProvider, Object.assign({}, formMethods),
            React.createElement("form", { onSubmit: formMethods.handleSubmit(onSubmit) },
                React.createElement(DrawerHeader, { showBackButton: false, title: "Add New Billing Address", onClose: () => {
                        hideDrawer();
                    } }),
                React.createElement(DrawerBody, null,
                    React.createElement("div", { className: "sui-grid sui-gap-y-6 sui-mb-10" },
                        React.createElement(AddressFields, null),
                        errorMessage && (React.createElement(Alert, { status: "error" }, ERR_UNABLE_TO_SAVE.message)))),
                React.createElement(DrawerFooter, null,
                    React.createElement("div", { className: "sui-flex sui-gap-2" },
                        React.createElement(Button, { fullWidth: true, variant: "secondary", onClick: () => {
                                hideDrawer();
                            } }, "Cancel"),
                        React.createElement(LoadingButton, { type: "submit", loading: isLoading, fullWidth: true }, "Save and Continue")))))));
};
